var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGainWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 42,
    height: 42,
    transform: "translate(364 551)",
    fill: "#ebc5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305eba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-364 -551)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weight",
    transform: "translate(364 551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M39.421,16.956h-.644V15.2a3.668,3.668,0,0,0-3.663-3.663H34.2a3.38,3.38,0,0,0-6.645.878v5.594H14.445V12.419A3.38,3.38,0,0,0,7.8,11.541H6.887A3.668,3.668,0,0,0,3.223,15.2v1.752H2.579A2.582,2.582,0,0,0,0,19.535v2.921a2.582,2.582,0,0,0,2.579,2.579h.644V26.8a3.668,3.668,0,0,0,3.663,3.663H7.8a3.38,3.38,0,0,0,6.645-.878V23.987H25.683a.615.615,0,0,0,0-1.23H14.445V19.244h13.11V29.581a3.38,3.38,0,0,0,6.645.878h.914A3.668,3.668,0,0,0,38.777,26.8V25.035h.644A2.582,2.582,0,0,0,42,22.456V19.535A2.582,2.582,0,0,0,39.421,16.956ZM3.223,23.8H2.579A1.35,1.35,0,0,1,1.23,22.456V19.535a1.35,1.35,0,0,1,1.349-1.349h.644Zm9.991,5.777a2.15,2.15,0,0,1-4.3,0V17.168a.615.615,0,1,0-1.23,0V29.229h-.8A2.436,2.436,0,0,1,4.454,26.8V15.2a2.436,2.436,0,0,1,2.433-2.433h.8v1.671a.615.615,0,1,0,1.23,0V12.419a2.15,2.15,0,1,1,4.3,0V29.581Zm19.871,0a2.15,2.15,0,0,1-4.3,0V12.419a2.15,2.15,0,0,1,4.3,0ZM37.546,26.8a2.436,2.436,0,0,1-2.433,2.433h-.8V12.771h.8A2.436,2.436,0,0,1,37.546,15.2Zm3.223-4.34A1.35,1.35,0,0,1,39.421,23.8h-.644V18.186h.644a1.35,1.35,0,0,1,1.349,1.349Z",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainWeight);
export default __webpack_public_path__ + "static/media/gain-weight.3f251fa728f0545220da5530f7e39129.svg";
export { ForwardRef as ReactComponent };